export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_16.898780dc.jpg";